export default "__VITE_ASSET__BOg78jZJ__"